import { useState, useEffect, useCallback } from 'react';

// Hook: trae TODOS los registros del periodo (para indicadores y gráficas), independiente
// de la paginación de la tabla. `fetchAll` se recrea cuando cambian los filtros (resetKey).
export const useRegistrosPeriodo = ({ fetchAll, resetKey, enabled = true }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError(null);
    try {
      const rows = await fetchAll();
      setData(Array.isArray(rows) ? rows : []);
    } catch (e) {
      setError(e.message || 'Error al cargar los indicadores');
      setData([]);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey, enabled]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
};
